var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3CeilingLampOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm47 58H22v-5h32v5zm11 0h-7v-5h4v-4H14v4h4v5h-7V11h25v5.91c-7.86.9-13.94 6.86-13.94 14.09h8.84a7.33 7.33 0 1014.32 0h8.84c0-7.27-6.14-13.26-14.06-14.11V11h25v54zM41 31a3.29 3.29 0 01.41 1.56 3.335 3.335 0 01-6.67 0 3.29 3.29 0 01.4-1.56H41zm-5 14h4v6h-4v-6zm13-6.62l4.24 4.24-2.83 2.83-4.24-4.24L49 38.38zm-21.82 0L30 41.21l-4.24 4.24-2.83-2.83 4.25-4.24z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Ceiling_lamp_off.55759fdc.svg";
export { SvgA3CeilingLampOff as ReactComponent };